export const quantityStepperStyles = {
  root: 'inline-flex items-center gap-1',
  value:
    'min-w-10 select-none text-center font-sans text-sm font-semibold tabular-nums text-brand-950',
} as const;
